export function applyOneTrustBannerA11yEnhancements() {
  const dialog = oneTrustElements.getCookieBannerDialog();

  if (!dialog) return;

  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-modal', 'true');
  dialog.setAttribute('tabindex', '-1');

  if (dialog.hasAttribute('aria-label') || dialog.hasAttribute('aria-labelledby')) return;

  dialog.setAttribute('aria-label', 'Cookie banner');
}

// ─── Constants ───────────────────────────────────────────────────────────────

const oneTrustElements = {
  getCookieBannerDialog: () =>
    document.querySelector('#onetrust-banner-sdk [role="dialog"]') ??
    document.querySelector('#onetrust-banner-sdk'),
};
